
import ResetPassword from "@/components/modal/ResetPassword.vue";
import { MutationTypes } from "@/store/modules/auth";
import { Inscription, InscriptionStatus } from "@/types/interface";
import axios from "axios";
import { defineComponent } from "vue";

export default defineComponent({
  components: {
    ResetPassword,
  },
  data() {
    return {
      email: null,
      password: null,
      showResetPasswordModal: false,
      errorMsg: "",
      persistentLogin: false,
    };
  },
  methods: {
    async login() {
      const response = await axios.post("login", {
        email: this.email,
        password: this.password,
      });

      if (response.status === 401) return (this.errorMsg = "Email incorrect");
      if (response.status === 400)
        return (this.errorMsg = "Mot de passe incorrect");

      if (response.status === 200) {
        this.$store.commit(
          `auth/${MutationTypes.SET_ACCESS_TOKEN}`,
          response.data.accessToken
        );
        this.$store.commit(
          `auth/${MutationTypes.SET_REFRESH_TOKEN}`,
          response.data.refreshToken
        );
        this.$store.commit(
          `auth/${MutationTypes.SET_ATHLETE_ID}`,
          response.data.athleteId
        );
        const base64Url =
          this.$store.getters["auth/getAccessToken"].split(".")[1];
        const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        const jsonPayload = decodeURIComponent(
          atob(base64)
            .split("")
            .map(function (c) {
              return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join("")
        );
        this.$store.commit(
          `auth/${MutationTypes.SET_USER}`,
          JSON.parse(jsonPayload).id
        );
        this.$store.dispatch("user/setMe").then(() => {
          if (
            this.$store.getters["user/getMe"].inscriptions.length == 0 ||
            !this.$store.getters["user/getMe"].inscriptions.some(
              (inscription: Inscription) =>
                inscription.edition.id ===
                  this.$store.getters["edition/getEditionId"] &&
                inscription.status !== InscriptionStatus.CANCELLED
            )
          ) {
            if (!this.$store.getters["edition/isRegistrationOpen"]) {
              return this.$router.push("/");
            }
            return this.$router.push({ name: "RegisterTeam" });
          }
          this.$router.push("/");
        });
        if (this.persistentLogin) {
          sessionStorage.setItem("accessToken", response.data.accessToken);
          sessionStorage.setItem("refreshToken", response.data.refreshToken);
        }
      }
    },
    toggleResetPasswordModal() {
      this.showResetPasswordModal = !this.showResetPasswordModal;
    },
  },
});
